/**
 * Coach buy button (snippets/coach-buy-form.liquid).
 *
 * Stripe bills the Coach (2026-10-13). The button is a link to the app's
 * /join, which creates the Stripe Checkout Session. This script does two
 * display-only jobs:
 *
 *   1. Every [data-coach-join] link gets any stored UTMs appended
 *      (utm-persistence.js, window.SwornUTM.getStored), so attribution
 *      reaches the Checkout Session's metadata. Once data-discount-ends has
 *      passed, ?code= is dropped, so an ended offer never reaches checkout.
 *   2. Offer expiry: the page can be served from a cache after an offer
 *      ends, so every .coach-offer-root with data-offer-ends
 *      (snippets/coach-price.liquid) drops .has-offer once that moment has
 *      passed, which shows the list price.
 *
 * Both run on load and on pageshow (back/forward cache). Without JS the
 * link still works. ES5, no dependencies.
 */
(function () {
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function nowSeconds() {
    return Date.now() / 1000;
  }

  function offerLive(endsAttr) {
    var ends = Number(endsAttr);
    return !!ends && nowSeconds() < ends;
  }

  function storedUtmQuery() {
    try {
      if (!window.SwornUTM || typeof window.SwornUTM.getStored !== 'function') return '';
      var utms = window.SwornUTM.getStored();
      if (!utms) return '';
      var params = [];
      for (var i = 0; i < UTM_KEYS.length; i++) {
        var key = UTM_KEYS[i];
        if (utms[key]) params.push(key + '=' + encodeURIComponent(utms[key]));
      }
      return params.join('&');
    } catch (e) {
      return '';
    }
  }

  function decorateJoinLinks() {
    try {
      var links = document.querySelectorAll('[data-coach-join]');
      for (var i = 0; i < links.length; i++) {
        var link = links[i];
        var url = link.getAttribute('data-join-base') || link.getAttribute('href');
        if (!url) continue;
        link.setAttribute('data-join-base', url);

        var ends = link.getAttribute('data-discount-ends');
        if (link.hasAttribute('data-discount-code') && !offerLive(ends)) {
          url = url.replace(/\?code=[^&]*&?/, '?').replace(/\?$/, '');
        }

        var utm = storedUtmQuery();
        if (utm) url += (url.indexOf('?') === -1 ? '?' : '&') + utm;

        link.setAttribute('href', url);
      }
    } catch (e) {
      // Display only; never block the page.
    }
  }

  function expireOffers() {
    try {
      var roots = document.querySelectorAll('.coach-offer-root.has-offer[data-offer-ends]');
      for (var i = 0; i < roots.length; i++) {
        if (!offerLive(roots[i].getAttribute('data-offer-ends'))) {
          roots[i].classList.remove('has-offer');
        }
      }
    } catch (e) {
      // Display only; never block the page.
    }
  }

  function run() {
    expireOffers();
    decorateJoinLinks();
  }

  window.addEventListener('pageshow', run);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
